import React from "react";
import "../styles/Footer.css";
import { FaWhatsapp, FaInstagram, FaFacebookF } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-bottom"></div>
      <div className="footer-container">
        {/* Column 1: Brand Info */}
        <div className="footer-col">
          <h3>VEDYO</h3>
          <p>
            A soulful yoga experience where tradition meets transformation.
            Grounded in nature, guided by purpose.
          </p>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#about">About</a></li>
            <li><a href="#classes">Classes</a></li>
            <li><a href="#trainers">Teacher</a></li>
            <li><a href="#inquiry">Inquiry</a></li>
          </ul>
        </div>

        {/* Column 3: Contact Info */}
        <div className="footer-col">
          <h4>Contact</h4>
          <p>Email: support@vedyo.in</p>
          <p>Phone: +91 97173 03190</p>
          <div className="social-icons">
            <a href="https://wa.me/919717303190" target="_blank" rel="noreferrer">
              <FaWhatsapp />
            </a>
            <a href="https://www.instagram.com/gurukulasharnam_?igsh=MWwwaGhvYW9idmF4Mg==" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="#" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} VEDYO. All rights reserved. <br />
        Developed by{" "}
        <a href="mailto:inquiry@dishastudioz.site">Disha Studioz</a>
      </div>
      <div className="footer-gap">
        <a>                  </a>
      </div>
    </footer>
  );
}

export default Footer;
